import { AnalyticsEvent } from "Shared/services/analytics/config";
import {
  ANALYTICS_EVENT_ATTRIBUTES,
  ANALYTICS_EVENT_NAMES,
  ANALYTICS_EVENT_SUB_TYPE,
  ANALYTICS_EVENT_TYPE,
} from "Shared/services/analytics/constants";
import { GA4_EVENT_CATEGORY, trackEventConditionally } from "Shared/services/analytics/services/thresholdManager";

/**
 * Sends analytic event for starting a dynamic screener survey
 * @param subType The sub type of the event
 * @param id The survey ID
 * @param providerId The provider ID
 * @param totalSteps Total number of screening questions
 * @returns void
 */
export const analyticsTrackDynamicScreenerStart = (
  surveyId    : string,
  providerId  : string,
  totalSteps  : number
): void => {
  const event: AnalyticsEvent = {
    event: ANALYTICS_EVENT_NAMES.start,
    attributes: {
      [ANALYTICS_EVENT_ATTRIBUTES.type]       : ANALYTICS_EVENT_TYPE.questionnaire,
      [ANALYTICS_EVENT_ATTRIBUTES.sub_type]   : ANALYTICS_EVENT_SUB_TYPE.survey_dynamic_screener,
      [ANALYTICS_EVENT_ATTRIBUTES.id]         : surveyId,
      [ANALYTICS_EVENT_ATTRIBUTES.provider_id]: providerId,
      [ANALYTICS_EVENT_ATTRIBUTES.total_steps]: totalSteps,
    }
  };

  trackEventConditionally(GA4_EVENT_CATEGORY.dynamic_screener, [event]);
};
